import { KITCHEN_CHARGES_COPY } from '@/components/KitchenCharges/copy';

const COPY = KITCHEN_CHARGES_COPY.date;
const DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;
const FIRST_MONTH = 1;
const NO_TEXT = '';

function readDate(isoText) {
  const match = DATE_PATTERN.exec(isoText || NO_TEXT);
  if (!match) return null;

  const [, year, month, day] = match;
  return { year: Number(year), month: Number(month), day: Number(day) };
}

export function dateLabel(isoText) {
  const date = readDate(isoText);
  if (!date) return NO_TEXT;

  const month = COPY.shortMonths[date.month - FIRST_MONTH];
  return month ? COPY.label(date.day, month, date.year) : NO_TEXT;
}
